import { Autocomplete, TextField, TextFieldProps } from "@mui/material";

interface IProps {
	list: any[];
	label?: string;
	value: any;
	valueFunction?(value: any): any;
	setValue(value: any): void;
	keyValue: string;
	keyItem?: string;
	keyTitle?: string;
	keyFunction?(item: any): string;
	inputProps?: TextFieldProps;
	className?: string;
}

const DataSelect = (props: IProps) => {
	const getTitle = (option: any) => {
		if (props.keyFunction) return props.keyFunction(option);
		return option[props.keyTitle || "name"];
	};

	return (
		<Autocomplete
			className={props.className || "w-[400px]"}
			disablePortal
			options={props.list}
			onChange={(e, v) => {
				var eventVal = { ...props.value };
				if (v) {
					eventVal[props.keyValue] = props.valueFunction
						? props.valueFunction(v[props.keyItem || "id"])
						: v[props.keyItem || "id"];
				} else delete eventVal[props.keyValue];
				props.setValue({ ...eventVal });
			}}
			value={
				props.list.find(
					(v) => v[props.keyItem || "id"] === props.value[props.keyValue]
				) || null
			}
			getOptionLabel={(option) => getTitle(option)}
			renderOption={(prop, option) => {
				return (
					<li {...prop} key={option[props.keyItem || "id"]}>
						{getTitle(option)}
					</li>
				);
			}}
			renderInput={(params) => (
				<TextField
					{...params}
					{...props.inputProps}
					label={props.label || ""}
					variant={"standard"}
				/>
			)}
		/>
	);
};

export default DataSelect;
